import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { journeyRadioIllustrationColors as colors } from './constants';
import { JourneyRadioIllustrationColors } from './types';

export const APICallEntrySource = ({
  height = 80,
  width = 80,
  backgroundColor = colors.backgroundColor,
  lineColor = colors.lineColor,
  fillColor = colors.fillColor,
}: SvgIconProps & JourneyRadioIllustrationColors) => (
  <SvgIcon width={width} height={height} viewBox="0 0 80 80" fill="none">
    <path
      d="M8 42.0449C8 50.5318 11.3714 58.6712 17.3726 64.6723C23.3737 70.6735 31.5131 74.0449 40 74.0449C48.4869 74.0449 56.6262 70.6735 62.6274 64.6723C68.6286 58.6712 72 50.5318 72 42.0449C72 33.558 68.6286 25.4187 62.6274 19.4175C56.6262 13.4163 48.4869 10.0449 40 10.0449C31.5131 10.0449 23.3737 13.4163 17.3726 19.4175C11.3714 25.4187 8 33.558 8 42.0449Z"
      fill={backgroundColor}
    />
    <path
      d="M14.1484 35.1348L39.2588 37.6452"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.1924 15.8836L39.2588 37.6452L57.6724 14.7676"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.5476 60.8077L39.258 37.6445L25.3076 54.6637"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9814 37.6451C26.9814 39.2572 27.299 40.8536 27.9159 42.343C28.5328 43.8324 29.4371 45.1857 30.577 46.3256C31.7169 47.4655 33.0702 48.3698 34.5596 48.9867C36.049 49.6036 37.6453 49.9211 39.2574 49.9211C40.8696 49.9211 42.4659 49.6036 43.9553 48.9867C45.4447 48.3698 46.798 47.4655 47.9379 46.3256C49.0778 45.1857 49.9821 43.8324 50.599 42.343C51.2159 40.8536 51.5334 39.2572 51.5334 37.6451C51.5334 36.033 51.2159 34.4367 50.599 32.9473C49.9821 31.4579 49.0778 30.1046 47.9379 28.9647C46.798 27.8248 45.4447 26.9205 43.9553 26.3036C42.4659 25.6867 40.8696 25.3691 39.2574 25.3691C37.6453 25.3691 36.049 25.6867 34.5596 26.3036C33.0702 26.9205 31.7169 27.8248 30.577 28.9647C29.4371 30.1046 28.5328 31.4579 27.9159 32.9473C27.299 34.4367 26.9814 36.033 26.9814 37.6451Z"
      fill="white"
    />
    <path
      d="M26.9814 37.6451C26.9814 39.2572 27.299 40.8536 27.9159 42.343C28.5328 43.8324 29.4371 45.1857 30.577 46.3256C31.7169 47.4655 33.0702 48.3698 34.5596 48.9867C36.049 49.6036 37.6453 49.9211 39.2574 49.9211C40.8696 49.9211 42.4659 49.6036 43.9553 48.9867C45.4447 48.3698 46.798 47.4655 47.9379 46.3256C49.0778 45.1857 49.9821 43.8324 50.599 42.343C51.2159 40.8536 51.5334 39.2572 51.5334 37.6451C51.5334 36.033 51.2159 34.4367 50.599 32.9473C49.9821 31.4579 49.0778 30.1046 47.9379 28.9647C46.798 27.8248 45.4447 26.9205 43.9553 26.3036C42.4659 25.6867 40.8696 25.3691 39.2574 25.3691C37.6453 25.3691 36.049 25.6867 34.5596 26.3036C33.0702 26.9205 31.7169 27.8248 30.577 28.9647C29.4371 30.1046 28.5328 31.4579 27.9159 32.9473C27.299 34.4367 26.9814 36.033 26.9814 37.6451Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.1035 35.9134C25.1403 32.2334 24.7099 28.9814 26.3035 27.3862C28.9187 24.771 35.9835 27.5974 42.0867 33.699C48.1899 39.8006 51.0163 46.867 48.4003 49.4798C47.1075 50.7718 44.7275 50.735 41.9139 49.6302"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.5203 30.9082C52.2019 30.8538 54.0219 31.3714 54.4003 32.489C55.2171 34.889 49.0971 39.1386 40.7323 41.9866C32.3675 44.8346 24.9243 45.1994 24.1083 42.8018C23.7275 41.6818 24.8539 40.1618 27.0123 38.5698"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.8564 33.6988C39.8564 33.9919 39.9142 34.2821 40.0263 34.5529C40.1385 34.8237 40.3029 35.0698 40.5102 35.2771C40.7174 35.4843 40.9635 35.6487 41.2343 35.7609C41.5051 35.8731 41.7953 35.9308 42.0884 35.9308C42.3816 35.9308 42.6718 35.8731 42.9426 35.7609C43.2134 35.6487 43.4594 35.4843 43.6667 35.2771C43.874 35.0698 44.0384 34.8237 44.1505 34.5529C44.2627 34.2821 44.3204 33.9919 44.3204 33.6988C44.3204 33.4057 44.2627 33.1154 44.1505 32.8446C44.0384 32.5738 43.874 32.3278 43.6667 32.1205C43.4594 31.9133 43.2134 31.7489 42.9426 31.6367C42.6718 31.5245 42.3816 31.4668 42.0884 31.4668C41.7953 31.4668 41.5051 31.5245 41.2343 31.6367C40.9635 31.7489 40.7174 31.9133 40.5102 32.1205C40.3029 32.3278 40.1385 32.5738 40.0263 32.8446C39.9142 33.1154 39.8564 33.4057 39.8564 33.6988Z"
      fill={fillColor}
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.6416 42.9561C34.6416 43.7364 34.9516 44.4849 35.5034 45.0367C36.0552 45.5885 36.8036 45.8985 37.584 45.8985C38.3644 45.8985 39.1128 45.5885 39.6646 45.0367C40.2164 44.4849 40.5264 43.7364 40.5264 42.9561C40.5264 42.1757 40.2164 41.4273 39.6646 40.8755C39.1128 40.3237 38.3644 40.0137 37.584 40.0137C36.8036 40.0137 36.0552 40.3237 35.5034 40.8755C34.9516 41.4273 34.6416 42.1757 34.6416 42.9561Z"
      fill={fillColor}
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.8604 14.7671C49.8604 16.8389 50.6834 18.826 52.1484 20.291C53.6135 21.756 55.6005 22.5791 57.6723 22.5791C59.7442 22.5791 61.7312 21.756 63.1963 20.291C64.6613 18.826 65.4844 16.8389 65.4844 14.7671C65.4844 12.6952 64.6613 10.7082 63.1963 9.24316C61.7312 7.77813 59.7442 6.95508 57.6723 6.95508C55.6005 6.95508 53.6135 7.77813 52.1484 9.24316C50.6834 10.7082 49.8604 12.6952 49.8604 14.7671Z"
      fill={fillColor}
    />
    <path
      d="M49.8604 14.7671C49.8604 16.8389 50.6834 18.826 52.1484 20.291C53.6135 21.756 55.6005 22.5791 57.6723 22.5791C59.7442 22.5791 61.7312 21.756 63.1963 20.291C64.6613 18.826 65.4844 16.8389 65.4844 14.7671C65.4844 12.6952 64.6613 10.7082 63.1963 9.24316C61.7312 7.77813 59.7442 6.95508 57.6723 6.95508C55.6005 6.95508 53.6135 7.77813 52.1484 9.24316C50.6834 10.7082 49.8604 12.6952 49.8604 14.7671Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7275 15.8829C19.7275 17.0669 20.1979 18.2023 21.035 19.0395C21.8722 19.8766 23.0076 20.3469 24.1915 20.3469C25.3755 20.3469 26.5109 19.8766 27.3481 19.0395C28.1852 18.2023 28.6555 17.0669 28.6555 15.8829C28.6555 14.699 28.1852 13.5636 27.3481 12.7264C26.5109 11.8893 25.3755 11.4189 24.1915 11.4189C23.0076 11.4189 21.8722 11.8893 21.035 12.7264C20.1979 13.5636 19.7275 14.699 19.7275 15.8829Z"
      fill="white"
    />
    <path
      d="M19.7275 15.8829C19.7275 17.0669 20.1979 18.2023 21.035 19.0395C21.8722 19.8766 23.0076 20.3469 24.1915 20.3469C25.3755 20.3469 26.5109 19.8766 27.3481 19.0395C28.1852 18.2023 28.6555 17.0669 28.6555 15.8829C28.6555 14.699 28.1852 13.5636 27.3481 12.7264C26.5109 11.8893 25.3755 11.4189 24.1915 11.4189C23.0076 11.4189 21.8722 11.8893 21.035 12.7264C20.1979 13.5636 19.7275 14.699 19.7275 15.8829Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7998 35.1371C10.7998 36.025 11.1525 36.8766 11.7804 37.5045C12.4083 38.1323 13.2599 38.4851 14.1478 38.4851C15.0357 38.4851 15.8873 38.1323 16.5152 37.5045C17.1431 36.8766 17.4958 36.025 17.4958 35.1371C17.4958 34.2491 17.1431 33.3975 16.5152 32.7697C15.8873 32.1418 15.0357 31.7891 14.1478 31.7891C13.2599 31.7891 12.4083 32.1418 11.7804 32.7697C11.1525 33.3975 10.7998 34.2491 10.7998 35.1371Z"
      fill={fillColor}
    />
    <path
      d="M10.7998 35.1371C10.7998 36.025 11.1525 36.8766 11.7804 37.5045C12.4083 38.1323 13.2599 38.4851 14.1478 38.4851C15.0357 38.4851 15.8873 38.1323 16.5152 37.5045C17.1431 36.8766 17.4958 36.025 17.4958 35.1371C17.4958 34.2491 17.1431 33.3975 16.5152 32.7697C15.8873 32.1418 15.0357 31.7891 14.1478 31.7891C13.2599 31.7891 12.4083 32.1418 11.7804 32.7697C11.1525 33.3975 10.7998 34.2491 10.7998 35.1371Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.96 54.6644C21.96 55.5524 22.3127 56.4039 22.9406 57.0318C23.5684 57.6597 24.42 58.0124 25.308 58.0124C26.1959 58.0124 27.0475 57.6597 27.6754 57.0318C28.3032 56.4039 28.656 55.5524 28.656 54.6644C28.656 53.7765 28.3032 52.9249 27.6754 52.297C27.0475 51.6691 26.1959 51.3164 25.308 51.3164C24.42 51.3164 23.5684 51.6691 22.9406 52.297C22.3127 52.9249 21.96 53.7765 21.96 54.6644Z"
      fill="white"
    />
    <path
      d="M21.96 54.6644C21.96 55.5524 22.3127 56.4039 22.9406 57.0318C23.5684 57.6597 24.42 58.0124 25.308 58.0124C26.1959 58.0124 27.0475 57.6597 27.6754 57.0318C28.3032 56.4039 28.656 55.5524 28.656 54.6644C28.656 53.7765 28.3032 52.9249 27.6754 52.297C27.0475 51.6691 26.1959 51.3164 25.308 51.3164C24.42 51.3164 23.5684 51.6691 22.9406 52.297C22.3127 52.9249 21.96 53.7765 21.96 54.6644Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.1768 59.878C48.1768 61.8013 48.9408 63.6459 50.3008 65.0059C51.6608 66.3659 53.5054 67.13 55.4288 67.13C57.3521 67.13 59.1967 66.3659 60.5567 65.0059C61.9167 63.6459 62.6808 61.8013 62.6808 59.878C62.6808 57.9546 61.9167 56.1101 60.5567 54.75C59.1967 53.39 57.3521 52.626 55.4288 52.626C53.5054 52.626 51.6608 53.39 50.3008 54.75C48.9408 56.1101 48.1768 57.9546 48.1768 59.878Z"
      fill="white"
    />
    <path
      d="M48.1768 59.878C48.1768 61.8013 48.9408 63.6459 50.3008 65.0059C51.6608 66.3659 53.5054 67.13 55.4288 67.13C57.3521 67.13 59.1967 66.3659 60.5567 65.0059C61.9167 63.6459 62.6808 61.8013 62.6808 59.878C62.6808 57.9546 61.9167 56.1101 60.5567 54.75C59.1967 53.39 57.3521 52.626 55.4288 52.626C53.5054 52.626 51.6608 53.39 50.3008 54.75C48.9408 56.1101 48.1768 57.9546 48.1768 59.878Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
